import { render } from "./echeances.vue?vue&type=template&id=738c1ca8"
import script from "./echeances.vue?vue&type=script&lang=ts"
export * from "./echeances.vue?vue&type=script&lang=ts"
script.render = render

export default script